import { CRMAPIBase } from './crmApiBase';
import { AddressGroup } from './methodGroups/addressGroup';
import { BatchGroup } from './methodGroups/batchGroup';
import { BrigadesGroup } from './methodGroups/brigadesGroup';
import { CallSettingsGroup } from './methodGroups/callSettingsGroup';
import { ChatGroup } from './methodGroups/chatGroup';
import { ContactsGroup } from './methodGroups/contactsGroup';
import { ChatGroupsGroup } from './methodGroups/chatGroupsGroup';
import { ChatMessageTopicGroup } from './methodGroups/chatMessageTopicGroup';
import { ChatMessagesGroup } from './methodGroups/chatMessagesGroup';
import { CRMGroup } from './methodGroups/crmGroup';
import { CustomerProfileGroup } from './methodGroups/customerProfileGroup';
import { EventGroup } from './methodGroups/eventGroup';
import { OrderFieldCategoriesGroup } from './methodGroups/fields/orderFieldCategoriesGroup';
import { OrderFieldsGroup } from './methodGroups/fields/orderFieldsGroup';
import { FileGroup } from './methodGroups/fileGroup';
import { ImportExportGroup } from './methodGroups/importExportGroup';
import { InvitationGroup } from './methodGroups/invitationGroup';
import { LandingGroup } from './methodGroups/langingGroup';
import { ModerationGroup } from './methodGroups/moderationGroup';
import { NotificationGroup } from './methodGroups/notificationGroup';
import { OrderDetailsGroup } from './methodGroups/orderDetailsGroup';
import { OrderGroup } from './methodGroups/orderGroup';
import { OrderObjectsGroup } from './methodGroups/orderObjectsGroup';
import { OrderReasonsGroup } from './methodGroups/orderReasonsGroup';
import { OrderStatusesGroup } from './methodGroups/orderStatusesGroup';
import { PaymentMethodsGroup } from './methodGroups/paymentMethodsGroup';
import { PermissionGroup } from './methodGroups/permissionGroup';
import { ProductAdminGroup } from './methodGroups/product/productAdminGroup';
import { ProductCategoryGroup } from './methodGroups/product/productCategoryGroup';
import { ProductGroup } from './methodGroups/product/productGroup';
import { ProfileGroup } from './methodGroups/profileGroup';
import { RegionGroup } from './methodGroups/regionGroup';
import { ReminderGroup } from './methodGroups/reminderGroup';
import { RequisiteGroup } from './methodGroups/requisiteGroup';
import { ResourceAdminGroup } from './methodGroups/resource/resourceAdminGroup';
import { ResourceCategoryGroup } from './methodGroups/resource/resourceCategoryGroup';
import { ResourceGroup } from './methodGroups/resource/resourceGroup';
import { ReviewGroup } from './methodGroups/review/reviewGroup';
import { ScheduleExceptionGroup } from './methodGroups/schedule/scheduleExceptionGroup';
import { ScheduleExceptionStatusGroup } from './methodGroups/schedule/scheduleExceptionStatusGroup';
import { ScheduleExceptionTypeGroup } from './methodGroups/schedule/scheduleExceptionTypeGroup';
import { ScheduleGroup } from './methodGroups/schedule/scheduleGroup';
import { ScheduleTemplateGroup } from './methodGroups/schedule/scheduleTemplateGroup';
import { SearchGroup } from './methodGroups/searchGroup';
import { SearchHistoryGroup } from './methodGroups/searchHistoryGroup';
import { SecurityGroup } from './methodGroups/securityGroup';
import { ServiceAdminGroup } from './methodGroups/service/serviceAdminGroup';
import { ServiceCategoryGroup } from './methodGroups/service/serviceCategoryGroup';
import { ServiceGroup } from './methodGroups/service/serviceGroup';
import { SettingsGroup } from './methodGroups/settingsGroup';
import { TaskAdminGroup } from './methodGroups/task/taskAdminGroup';
import { TaskCategoryGroup } from './methodGroups/task/taskCategoryGroup';
import { TaskGroup } from './methodGroups/task/taskGroup';
import { TransactionsGroup } from './methodGroups/transactionsGroup';
import { UserGroup } from './methodGroups/userGroup';
import { WarehousesGroup } from './methodGroups/warehousesGroup';
import { WorksScheduleGroup } from './methodGroups/workScheduleGroup';
import { WorkerPositionGroup } from './methodGroups/workerPositionGroup';
import { WorksheetGroup } from './methodGroups/worksheetGroup';

class CRMAPI extends CRMAPIBase {}

interface CRMAPI
    extends SecurityGroup,
        UserGroup,
        RequisiteGroup,
        CustomerProfileGroup,
        WorkerPositionGroup,
        OrderGroup,
        OrderDetailsGroup,
        ProfileGroup,
        InvitationGroup,
        ProductCategoryGroup,
        ProductGroup,
        ProductAdminGroup,
        FileGroup,
        ServiceCategoryGroup,
        ServiceGroup,
        ServiceAdminGroup,
        TransactionsGroup,
        PermissionGroup,
        WorksheetGroup,
        ChatMessageTopicGroup,
        ChatMessagesGroup,
        OrderFieldsGroup,
        TaskGroup,
        TaskCategoryGroup,
        TaskAdminGroup,
        OrderObjectsGroup,
        OrderReasonsGroup,
        BatchGroup,
        SearchGroup,
        SearchHistoryGroup,
        ScheduleExceptionTypeGroup,
        ScheduleExceptionStatusGroup,
        ScheduleExceptionGroup,
        ScheduleTemplateGroup,
        ScheduleGroup,
        SettingsGroup,
        ImportExportGroup,
        NotificationGroup,
        ResourceCategoryGroup,
        ResourceGroup,
        BrigadesGroup,
        AddressGroup,
        RegionGroup,
        EventGroup,
        WorksScheduleGroup,
        ReminderGroup,
        ResourceAdminGroup,
        LandingGroup,
        ReviewGroup,
        ChatGroupsGroup,
        ChatGroup,
        OrderStatusesGroup,
        PaymentMethodsGroup,
        OrderFieldCategoriesGroup,
        WarehousesGroup,
        CallSettingsGroup,
        ContactsGroup,
        ModerationGroup,
        CRMGroup {}

function applyMixins(derivedCtor: any, baseCtors: any[]) {
    baseCtors.forEach((baseCtor) => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
            if (name !== 'constructor') {
                derivedCtor.prototype[name] = baseCtor.prototype[name];
            }
        });
    });
}

applyMixins(CRMAPI, [
    SecurityGroup,
    UserGroup,
    RequisiteGroup,
    CustomerProfileGroup,
    WorkerPositionGroup,
    OrderGroup,
    OrderDetailsGroup,
    ProfileGroup,
    InvitationGroup,
    ProductCategoryGroup,
    ProductGroup,
    ProductAdminGroup,
    FileGroup,
    ServiceCategoryGroup,
    ServiceGroup,
    ServiceAdminGroup,
    TransactionsGroup,
    PermissionGroup,
    WorksheetGroup,
    ChatMessageTopicGroup,
    ChatMessagesGroup,
    OrderFieldsGroup,
    TaskGroup,
    TaskCategoryGroup,
    TaskAdminGroup,
    OrderObjectsGroup,
    OrderReasonsGroup,
    CRMGroup,
    BatchGroup,
    SearchGroup,
    SearchHistoryGroup,
    ScheduleExceptionTypeGroup,
    ScheduleExceptionStatusGroup,
    ScheduleExceptionGroup,
    ScheduleTemplateGroup,
    ScheduleGroup,
    SettingsGroup,
    ImportExportGroup,
    NotificationGroup,
    ResourceCategoryGroup,
    ResourceGroup,
    ResourceAdminGroup,
    BrigadesGroup,
    AddressGroup,
    RegionGroup,
    EventGroup,
    WorksScheduleGroup,
    LandingGroup,
    ReminderGroup,
    ReviewGroup,
    ChatGroup,
    ChatGroupsGroup,
    OrderStatusesGroup,
    PaymentMethodsGroup,
    OrderFieldCategoriesGroup,
    WarehousesGroup,
    CallSettingsGroup,
    ContactsGroup,
    ModerationGroup,
]);

export { CRMAPI };
